import { render } from "./CategoryNavDropdown.vue?vue&type=template&id=05b60230"
import script from "./CategoryNavDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryNavDropdown.vue?vue&type=script&lang=js"

import "./CategoryNavDropdown.vue?vue&type=style&index=0&id=05b60230&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__